import React, { useState } from 'react';
import { Headphones, ChevronDown, ChevronUp, ExternalLink } from 'lucide-react';
export function ListenInsteadOfReading() {
  const [showDetails, setShowDetails] = useState(false);
  return <div className="mt-12 bg-gray-50 rounded-lg border border-gray-200 p-6" data-id="element-384">
      <div className="flex items-start" data-id="element-385">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-brand-purple-100 flex items-center justify-center mr-4" data-id="element-386">
          <Headphones className="w-5 h-5 text-brand-purple-600" aria-hidden="true" data-id="element-387" />
        </div>
        <div className="flex-1" data-id="element-388">
          <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-389">
            Prefer to listen instead of read?
          </h3>
          <p className="text-base text-gray-700 leading-relaxed mb-3" data-id="element-390">
            Many devices and browsers include built-in tools that can read
            webpage text aloud. Students may also choose a third-party
            text-to-speech tool, such as NaturalReader, if they prefer listening
            to course or help content.
          </p>
          <p className="text-sm text-gray-600 leading-relaxed" data-id="element-391">
            NaturalReader offers free text-to-speech options, but Desert Sage
            Seminars does not require a specific tool and does not provide
            support for third-party extensions or apps. Please use whichever
            read-aloud option works best on your device.
          </p>

          {/* Subtle third-party links */}
          <div className="mt-4 flex flex-wrap gap-2" data-id="element-392">
            <a href="https://www.naturalreaders.com/online/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-purple-500" data-id="element-393">
              Open NaturalReader
              <ExternalLink className="w-3.5 h-3.5 ml-1.5" aria-hidden="true" data-id="element-394" />
            </a>
            <a href="https://chromewebstore.google.com/search/NaturalReader%20text%20to%20speech" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-purple-500" data-id="element-395">
              Find NaturalReader Extension
              <ExternalLink className="w-3.5 h-3.5 ml-1.5" aria-hidden="true" data-id="element-396" />
            </a>
          </div>

          <button onClick={() => setShowDetails(open => !open)} className="mt-4 inline-flex items-center text-sm font-medium text-brand-purple-600 hover:text-brand-purple-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-purple-500 rounded" aria-expanded={showDetails} aria-controls="tts-help-details" data-id="element-397">
            How to get started
            {showDetails ? <ChevronUp className="w-4 h-4 ml-1" aria-hidden="true" data-id="element-398" /> : <ChevronDown className="w-4 h-4 ml-1" aria-hidden="true" data-id="element-399" />}
          </button>

          {showDetails && <div id="tts-help-details" className="mt-4 space-y-3 border-t border-gray-200 pt-4" data-id="element-400">
              <div data-id="element-401">
                <p className="text-sm font-semibold text-gray-900" data-id="element-402">
                  Chrome / Edge
                </p>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-403">
                  Install a text-to-speech browser extension such as
                  NaturalReader, return to the page you want to listen to, then
                  use the extension's play controls.
                </p>
              </div>
              <div data-id="element-404">
                <p className="text-sm font-semibold text-gray-900" data-id="element-405">
                  iPhone / iPad
                </p>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-406">
                  Use Apple's built-in Spoken Content or Speak Screen
                  accessibility tools.
                </p>
              </div>
              <div data-id="element-407">
                <p className="text-sm font-semibold text-gray-900" data-id="element-408">Android</p>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-409">
                  Use Android's Select to Speak or built-in accessibility
                  read-aloud tools.
                </p>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}